import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Config } from 'src/app/shared/models/config';
import { Context } from 'src/app/shared/models/context';
import { Journel } from 'src/app/shared/models/finance';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { FinanceService } from 'src/app/shared/services/finance.service';
import { JournelCrudComponent } from '../journel-crud/journel-crud.component';

@Component({
  selector: 'app-journel-list',
  templateUrl: './journel-list.component.html',
  styleUrls: ['./journel-list.component.scss'],
})
export class JournelListComponent implements OnInit {
  public journels: Journel[] = [];
  public context: Context;
  constructor(
    private modalService: NgbModal,
    private financeService: FinanceService,
    private commonService: CommonService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {}
  //   const ctxEmpId: number = this.commonService.getSessionItem(
  //     Config.context
  //   )?.companyId;
  //   this.authService.getContext().subscribe((context) => {
  //     if (ctxEmpId) {
  //       this.context = context;
  //       this.getjournals();
  //     }
  //   });
  // }
  // public upsertJournel(journel?: Journel) {
  //   const modalRef = this.modalService.open(JournelCrudComponent, {
  //     size: 'xl',
  //     backdrop: 'static',
  //   });
  //   modalRef.componentInstance.journel = journel;
  //   modalRef.componentInstance.required = false;
  //   modalRef.result
  //     .then((response: Journel) => {
  //       this.getjournals();
  //     })
  //     .catch((error) => {
  //       //Close event
  //     });
  // }
  // public deleteJournel(journel) {
  //   this.commonService.confirmation().subscribe({
  //     next: (response) => {
  //       if (response) {
  //         this.financeService.deleteJournel(journel.id).subscribe({
  //           next: (message: boolean) => {
  //             if (message) {
  //               this.journels.splice(this.journels.indexOf(journel), 1);
  //               this.toastr.success('Journal deleted successfully!');
  //             } else this.toastr.warning('Journal cannot be deleted ');
  //           },
  //           error: (error: HttpErrorResponse) => {
  //             this.commonService.setToastr(error.status, error.message);
  //           },
  //         });
  //       }
  //     },
  //   });
  // }
  // private getjournals() {
  //   const ctxEmpId: number = this.commonService.getSessionItem(
  //     Config.context
  //   )?.companyId;
  //   if (ctxEmpId) {
  //     this.financeService
  //       .getJournels(ctxEmpId)
  //       .subscribe((journels) => (this.journels = journels));
  //   }
  // }
}
